import { VolumeReportsState } from "@app/reports/volume-reports/import/interfaces";
import { expandCollapse } from "@app/shared/qes-standards/utility/expandCollapse";
import { FC, useContext, useMemo, useRef } from "react";
import { VolumeReportsContext } from "@app/reports/volume-reports/import/VolumeReportsContext";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";

interface StateAccordionProps {
    state: VolumeReportsState;
}

export const VolumeReportsStateAccordion: FC<React.PropsWithChildren<StateAccordionProps>> = (props: StateAccordionProps) => {
    const countyListRef = useRef<HTMLUListElement>(null);
    const iconRef = useRef<HTMLButtonElement>(null);
    const wizardContext = useContext(VolumeReportsContext);

    const handleOpen = () => {
        iconRef.current.style.transform = "rotate(90deg)";
    }

    const handleClose = () => {
        iconRef.current.style.transform = null;
    }

    const counties = useMemo(() => {
        return props.state.childServiceAreas.filter((child) => child.isVisible).map((child) => (
            <li key={child.displayName}>
                {child.displayName}
            </li>
        ));
    }, [props.state.checkboxState, props.state.isVisible, props.state.childServiceAreas]);

    return (
        <ul className="vr__list" onClick={() => { expandCollapse(countyListRef, handleClose, handleOpen); }}>
            <li>
                <QESButton
                    className="vr__collapse-indicator"
                    qesType="none"
                    qesTestId={`vr__list-collapse-toggle--${props.state.displayName}`}
                    onClick={(e) => e.preventDefault()}
                    qesRef={iconRef}
                    disabled={wizardContext.reportType !== "stateaggregate" ? false : true}
                    hidden={wizardContext.reportType !== "stateaggregate" ? false : true}
                >
                    <QesIcon iconName={QesIcons.ChevronRight} description="Expand"/>
                </QESButton>
                {props.state.displayName}
                <ul className="vr__list qes-js-closed" ref={countyListRef} onClick={(e) => { e.stopPropagation(); }}>
                    {wizardContext.reportType !== "stateaggregate" && counties}
                </ul>
            </li>
        </ul>
    );
}
